module.exports = __webpack_public_path__ + "static/media/feature.2248e63e.png";